import { ca } from '@cian/analytics';

export const trackRealEstateTabClick = (name: string) => {
  ca('eventSite', {
    action: 'Click',
    label: `Tab_${name}`,
    category: 'IpotekaSuburban',
    name: 'oldevent',
    page: {
      pageType: 'SuburnabIpotekaLanding',
    },
  });
};

export const trackProgramClick = (tabName: string, programName?: string) => {
  const label = ['Tab', tabName, 'Program', programName].filter(Boolean).join('_');

  ca('eventSite', {
    action: 'Click',
    label,
    category: 'IpotekaSuburban',
    name: 'oldevent',
    page: {
      pageType: 'SuburnabIpotekaLanding',
    },
  });
};
